/*
 * @Description: 自然人
 * @Date: 2024-11-20 11:31:30
 */
import { taxPayment } from '@/api/ajax';
import fields, {
  delDisabled,
  uploadDisabled,
  downloadDisabled
} from './fields';
import search, { kfqy } from './search';
import TableRenderClass from '@/components/tableRender/tableRenderClass';
import Add from '../add.vue';

const example = new TableRenderClass({ fields, search });

/*自然人*/
export const personMain = isYyjd => {
  const baseTable = example.createPart({
    name: '我收到的',
    showClearAll: true,
    search: [
      kfqy({
        tip: '请选择供应商',
        key: 'customerName',
        ajax: taxPayment.person.selectBox,
        prop: {
          label: 'customerName',
          code: 'customerName'
        },
        query: {
          type: 1
        },
        ajaxQuery: 'keyWord'
      }),

      'monthrange'
    ],
    list: data => {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async resolve => {
        const res = await taxPayment.person.list({
          ...data,
          proofType: 1
        });
        resolve(res);
      });
    },
    requestNow: true,
    fields: [
      'index',
      {
        label: '供应商',
        formatter: row => {
          const { proofType, csoName, supplierName } = row;
          return ['', supplierName, csoName][proofType] || '-';
        }
      },
      'wsqy',
      'qyNo',
      'month',
      'startDate',
      'endDate',
      'wsCount',
      'uploadDt',
      {
        label: '操作',
        width: '120px',
        showToolTip: false,
        render: function(h, ctx, r) {
          const vm = ctx.parent;
          return (
            <div>
              <el-button
                type="text"
                onClick={() => {
                  vm.$xrkDialog({
                    title: '完税证明',
                    width: '1000px',
                    showCancel: false,
                    showConfirm: false,
                    $slots: {
                      default: vm.$createElement(Add, {
                        props: {
                          id: r.id,
                          addType: 2,
                          useType: 2,
                          getAjax: () => {
                            return taxPayment.person.detail({
                              id: r.id,
                              type: 1
                            });
                          }
                        },
                        on: {
                          confirm: () => {
                            vm.saveSuccess();
                            vm.$xrkDialog.remove();
                          }
                        }
                      })
                    }
                  });
                }}
              >
                查看
              </el-button>
              <el-button
                type="text"
                disabled={downloadDisabled(r.auditStatus)}
                onClick={() => {
                  taxPayment.person.downloadAnnexAjax({ id: r.id }).then(() => {
                    vm.$message.success('下载成功，前往下载中心查看');
                  });
                }}
              >
                下载
              </el-button>
            </div>
          );
        }
      }
    ]
  });
  return [
    {
      name: '完税证明',
      childMenu: isYyjd
        ? [
            example.createPart({
              name: '我发起的',
              search: [
                kfqy({
                  key: 'customerName',
                  ajax: taxPayment.person.selectBox,
                  prop: {
                    label: 'showEnterpriseName',
                    code: 'customerName'
                  },
                  query: {
                    type: 2
                  },
                  ajaxQuery: 'keyWord'
                }),
                'monthrange',
                'status'
              ],
              showClearAll: true,
              list: data => {
                // eslint-disable-next-line no-async-promise-executor
                return new Promise(async resolve => {
                  const res = await taxPayment.person.list({
                    ...data,
                    proofType: 2
                  });
                  resolve(res);
                });
              },
              defaultQuery: { auditStatus: 0 },
              moreBtnArr: [
                {
                  name: '新增完税证明',
                  type: 'warning',
                  async fn(app, table) {
                    table.$xrkDialog({
                      title: '新增完税证明',
                      width: '1000px',
                      showCancel: false,
                      showConfirm: false,
                      $slots: {
                        default: table.$createElement(Add, {
                          props: {
                            addType: 1,
                            useType: 1,
                            saveAjax: taxPayment.person.add,
                            customerAjax: taxPayment.person.settleCompany
                          },
                          on: {
                            confirm: () => {
                              table.saveSuccess();
                              table.$xrkDialog.remove();
                            }
                          }
                        })
                      }
                    });
                  }
                }
              ],
              requestNow: true,
              fields: [
                'index',
                'customerName',
                'phone',
                'qyNo',
                'month',
                'startDate',
                'endDate',
                'wsCount',
                'newDt',
                'uploadUserPhone',
                'auditStatus',
                {
                  label: '操作',
                  width: '240px',
                  showToolTip: false,
                  render: function(h, ctx, r) {
                    const vm = ctx.parent;
                    return (
                      <div>
                        <el-button
                          type="text"
                          onClick={() => {
                            vm.$xrkDialog({
                              title: '完税证明',
                              width: '1000px',
                              showCancel: false,
                              showConfirm: false,
                              $slots: {
                                default: vm.$createElement(Add, {
                                  props: {
                                    id: r.id,
                                    addType: 2,
                                    useType: 1,
                                    getAjax: () => {
                                      return taxPayment.person.detail({
                                        id: r.id,
                                        type: 1
                                      });
                                    }
                                  }
                                })
                              }
                            });
                          }}
                        >
                          查看
                        </el-button>
                        <el-button
                          type="text"
                          disabled={delDisabled(r.auditStatus)}
                          onClick={() => {
                            vm.$confirm('是否删除?', '提示', {
                              confirmButtonText: '确定',
                              cancelButtonText: '取消',
                              type: 'warning'
                            }).then(() => {
                              taxPayment.person
                                .detail({
                                  id: r.id,
                                  type: 3
                                })
                                .then(() => {
                                  vm.saveSuccess();
                                  vm.$message.success('删除成功');
                                });
                            });
                          }}
                        >
                          删除
                        </el-button>
                        <el-button
                          type="text"
                          disabled={uploadDisabled(r)}
                          onClick={() => {
                            vm.$xrkDialog({
                              title: '完税证明',
                              width: '1000px',
                              showCancel: false,
                              showConfirm: false,
                              $slots: {
                                default: vm.$createElement(Add, {
                                  props: {
                                    id: r.id,
                                    addType: 5,
                                    useType: 1,
                                    getAjax: () => {
                                      return taxPayment.person.detail({
                                        id: r.id,
                                        type: 2
                                      });
                                    },
                                    saveAjax: taxPayment.person.add
                                  },
                                  on: {
                                    confirm: () => {
                                      vm.saveSuccess();
                                      vm.$xrkDialog.remove();
                                    }
                                  }
                                })
                              }
                            });
                          }}
                        >
                          上传
                        </el-button>
                        <el-button
                          type="text"
                          disabled={downloadDisabled(r.auditStatus)}
                          onClick={() => {
                            taxPayment.person
                              .downloadAnnexAjax({ id: r.id })
                              .then(() => {
                                vm.$message.success(
                                  '下载成功，前往下载中心查看'
                                );
                              });
                          }}
                        >
                          下载
                        </el-button>
                      </div>
                    );
                  }
                }
              ]
            }),
            baseTable
          ]
        : [baseTable]
    }
  ];
};
